import axios from "axios"
import { useEffect, useState } from "react"
import { MdSearch } from "react-icons/md"
import { apis } from "../api/apiUrl"

const Search = ({ handleSetData, faculty, level }) => {
    const [search, setSearch] = useState("")

    useEffect(() => {

        const id = setTimeout(() => {
            if (search !== "") {
                axios.post(`${apis.uniten_api}/SearchCourse`, {
                    "college": faculty,
                    "educationType": level,
                    "search": search
                }).then(res => {

                    handleSetData(res.data)
                })
            }
            else{
                handleSetData([])
            }
        }, 800)

        return () => clearTimeout(id)



    }, [search])
    return (
        <>
            <input type="text" placeholder="Search" className="outline-none border-0 w-full px-4 font-bold" value={search} onChange={(e) => setSearch(e.target.value)} />
            <MdSearch className="2xl:w-8 2xl:h-8" />
        </>
    )
}

export default Search